module.exports = function getResource(label, vars = []) {
    let resources = {
        findInStore: 'Find in a Sephora store',
        postal: 'Postal code',
        zip: 'ZIP code',
        within: 'Within',
        find: 'FIND',
        inStock: 'In Stock',
        viewMap: 'View map',
        showMore: 'Show more',
        sorry: 'We’re sorry, this item is not available within',
        selected: 's of your selected ZIP/Postal code',
        mile: 'mile',
        kilometer: 'kilometer',
        away: 'away'
    };

    return resources[label];
};
